export const FeedbackActionTypes = {
  GET_FEEDBACK_DATA: 'GET_FEEDBACK_DATA',
};
